/* eslint-disable no-console */
/* eslint-disable max-len */
import { FormControl, FormControlLabel, RadioGroup } from '@mui/material';
import React, { useContext, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { LanguageContext } from '../../../libs/Context';
import Radio from '@mui/material/Radio';

const FileExistPopup = (props) =>
{
	const { language } = useContext(LanguageContext);
	const { openDialog, isPausedRef, setProgress } = props;
	const [ selected, setSelected ] = useState<any>('cancel');

	const handleSubmit = () =>
	{
		setProgress(true);
		isPausedRef.current = { wait: false, replace: selected };
	};

	const handleClose = () =>
	{
		isPausedRef.current = { wait: false, replace: 'cancel' };
	};

	return (
		<div>
			<Dialog open={openDialog}>
				<DialogTitle>{language?.info}</DialogTitle>
				<DialogContent>
					<DialogContentText>
						{language?.alreadyExists}
					</DialogContentText>
					<DialogContentText>
						<FormControl>
							<RadioGroup
								aria-labelledby='demo-radio-buttons-group-label'
								defaultValue='Update existing file'
								name='radio-buttons-group'
								onChange={(event) =>
								{
									setSelected(event.target.value);
								}}
								value={selected}
							>
								<FormControlLabel
									value='yes'
									control={<Radio />}
									label={language?.updateExistingFile}
								/>
								<FormControlLabel
									value='no'
									control={<Radio />}
									label={language?.keepBothFiles}
								/>
							</RadioGroup>
						</FormControl>
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button
						disableElevation
						disableRipple
						autoFocus
						onClick={handleClose}
					>
						{language?.cancel}
					</Button>
					<Button
						disableElevation
						disableRipple
						variant='contained'
						className='whiteTxt'
						onClick={handleSubmit}
						disabled={![ 'yes', 'no' ].includes(selected)}
					>
						{language?.upload}
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default FileExistPopup;
